export const clientSideOnly = <T,>(x: T): T | null => x;
